"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpButtonMainNavigation = void 0;
const auth0_react_1 = require("@auth0/auth0-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const useHelpUrl_1 = __importDefault(require("../../hooks/useHelpUrl"));
const HelpButtonMainNavigation = () => {
    const url = (0, useHelpUrl_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isAuthenticated } = (0, auth0_react_1.useAuth0)();
    if (!url || !isAuthenticated) {
        return null;
    }
    return (react_1.default.createElement("a", { href: url, target: "_blank", rel: "noreferrer", className: "btn znd-main-navigation__help-button", title: t('help.button_title') ?? undefined },
        react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.questionCircle })));
};
exports.HelpButtonMainNavigation = HelpButtonMainNavigation;
exports.default = exports.HelpButtonMainNavigation;
